import script from "./invoices-table.vue?vue&type=script&setup=true&lang=js"
export * from "./invoices-table.vue?vue&type=script&setup=true&lang=js"

import "./invoices-table.vue?vue&type=style&index=0&id=ec34e6f8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec34e6f8"]])

export default __exports__